import SectionHeading from "./SectionHeading";
import { testimonials } from "@/mocks/skincare";

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-primary-500 text-sm"></i>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100/60">
      <div className="max-w-6xl mx-auto flex flex-col gap-12">
        <SectionHeading
          eyebrow="Reviews"
          title="고객님들의 생생한 후기"
          description="비앙카와 함께 피부 고민을 해결해나가고 있는 고객님들의 소중한 이야기입니다."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((review) => (
            <div
              key={review.id}
              className="flex flex-col gap-4 p-6 rounded-2xl bg-white border border-background-200/70"
            >
              <div className="flex items-center justify-between">
                <Stars count={review.rating} />
                <i className="ri-double-quotes-r text-3xl text-primary-200"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{review.text}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                <span className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm">
                  {review.name.charAt(0)}
                </span>
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-foreground-900">{review.name}</span>
                  <span className="text-xs text-foreground-500">{review.tag}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}